import React from 'react';
export const cloneSvg = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2001_48)">
                <path d="M4 4H14.6667V6.66667H16V4C16 3.64638 15.8595 3.30724 15.6095 3.05719C15.3594 2.80714 15.0203 2.66667 14.6667 2.66667H4C3.64638 2.66667 3.30724 2.80714 3.05719 3.05719C2.80714 3.30724 2.66666 3.64638 2.66666 4V14.6667C2.66666 15.0203 2.80714 15.3594 3.05719 15.6095C3.30724 15.8595 3.64638 16 4 16H6.66666V14.6667H4V4Z" fill="white"/>
                <path d="M20 8H9.33333C8.97971 8 8.64057 8.14048 8.39052 8.39052C8.14048 8.64057 8 8.97971 8 9.33333V20C8 20.3536 8.14048 20.6928 8.39052 20.9428C8.64057 21.1929 8.97971 21.3333 9.33333 21.3333H20C20.3536 21.3333 20.6928 21.1929 20.9428 20.9428C21.1929 20.6928 21.3333 20.3536 21.3333 20V9.33333C21.3333 8.97971 21.1929 8.64057 20.9428 8.39052C20.6928 8.14048 20.3536 8 20 8ZM20 20H9.33333V9.33333H20V20Z" fill="white"/>
                <path d="M14 18.6667H15.3333V15.3333H18.6667V14H15.3333V10.6667H14V14H10.6667V15.3333H14V18.6667Z" fill="white"/>
            </g>
            <defs>
                <clipPath id="clip0_2001_48">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}